import React, { useCallback } from 'react'
import { useTranslation } from 'react-i18next'
import { getCustomerCallThunk } from '../../../redux/thunk/customer'
import { useDispatch, useSelector } from 'react-redux'
import { setAppEvent, setAppModal } from '../../../redux/action/system'
import Button from '../../Elements/buttons/Button'
import { useNavigate } from 'react-router-dom'
import { useWindowBreakPoint } from '../../../hooks/useWindowBreakPoint'
import { theme } from '../../../style/theme'

const CustomerMenu = React.memo(({ onSelectOrderType }) => {
	const { t } = useTranslation()
	const dispatch = useDispatch()
	const navigate = useNavigate()
	const incomeModalShow = useSelector(store => store.system.modal.incomeModalShow)
	const isTablet = useWindowBreakPoint(theme.point820)

	const handleCustomerCalls = useCallback(() => {
		dispatch(getCustomerCallThunk())
		dispatch(setAppModal({ incomeModalShow: !incomeModalShow }))
		dispatch(setAppEvent({ eventCall: true }))
	}, [incomeModalShow, dispatch])

	const openPickupMonitor = useCallback(() => {
		navigate('/delivery/pickup-monitor')
	}, [navigate])

	return (
		<>
			<Button icon="phone" text={t('Modal.incoming_call.title')} keyButton="F3"
							showTextForMobile={false} color="green" size="small" zIndex={0} onClick={handleCustomerCalls} />
			{isTablet &&
				<>
					<Button icon="pickup" text={t('AddOrder.Client.menu.Selbstabholer')} keyButton="F5"
									showTextForMobile={false} color="blue" size="small" zIndex={0}
									onClick={() => onSelectOrderType('PICKUP')} />
					<Button icon="counter" text={t('AddOrder.Client.menu.Hausverkauf')} keyButton="F6"
									showTextForMobile={false} color="blue" size="small" zIndex={0}
									onClick={() => onSelectOrderType('COUNTER')} />
				</>}
			<Button icon="pickup-monitor" text={t('Cart.Buttons.pickupMonitor')} color="blue"
							showTextForTablet={false}
							size="small" zIndex={0} onClick={openPickupMonitor} />
		</>
	)
})

CustomerMenu.displayName = 'CustomerMenu'
export default CustomerMenu
